<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path fill="#fc8f00" d="M19,27h10v16H19V27z" />
    <path
      fill="#00acc1"
      d="M40,46H8c0-11.014,11-13,11-13l5,9l5-9C29,33,40,35.025,40,46z"
    />
    <path
      fill="#263238"
      d="M17,39c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S18.657,39,17,39z"
    />
    <path
      fill="#cfd8dc"
      d="M16,42c0-0.553,0.447-1,1-1c0.552,0,1,0.447,1,1s-0.448,1-1,1C16.447,43,16,42.553,16,42z M29,44h-2 v2h2V44z M35,44h-2v2h2V44z"
    />
    <path
      fill="#37474f"
      d="M19,33v-3.363c-1.081,1.294-1.792,2.577-1.949,3.046C16.535,34.234,16,35.838,16,40 c0,0.553,0.448,1,1,1s1-0.447,1-1c0-3.838,0.461-5.22,0.949-6.684c0.02-0.06,0.055-0.14,0.099-0.231L19,33z M31.984,39.124 c-0.126-3.667-0.996-6.324-1.05-6.482c-0.579-1.51-1.227-2.737-1.934-3.71V33l-0.043,0.078c0.032,0.08,0.064,0.16,0.095,0.238 c0.009,0.026,0.806,2.462,0.931,5.815C27.654,39.75,27,42.474,27,44l2,0.003C29.001,43.881,29.042,41,31,41s1.999,2.881,2,3h2 C35,42.466,34.339,39.726,31.984,39.124z"
    />
    <path
      fill="#fc8f00"
      d="M17,21c0,1.106-0.895,2-2,2s-2-0.894-2-2c0-1.105,0.894-2,2-2S17,19.895,17,21 M35,21 c0-1.105-0.895-2-2-2s-2,0.895-2,2c0,1.106,0.895,2,2,2S35,22.106,35,21"
    />
    <path
      fill="#ffaa45"
      d="M33,15c0-7.635-18-4.971-18,0v7c0,4.971,4.029,9,9,9s9-4.029,9-9V15z"
    />
    <path
      fill="#784719"
      d="M27,21c0-0.551,0.448-1,1-1s1,0.449,1,1s-0.448,1-1,1S27,21.551,27,21 M19,21c0,0.551,0.448,1,1,1 s1-0.449,1-1s-0.448-1-1-1S19,20.449,19,21"
    />
    <path
      fill="#795548"
      d="M24,6c-6.075,0-10,4.926-10,11v2.286L16,21v-5l12-4l4,4v5l2-1.742V17c0-4.025-1.038-8.016-6-9l-1-2 H24z"
    />
    <path
      fill="#00acc1"
      d="M33,7c0,0-1.875-2-8.75-2C17.376,5,15,7,15,7s-1,6-1,10c0,0,5-1,10-1s10,1,10,1C34,13,33,7,33,7z"
    />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "DoctorMaleIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
